import React from 'react';
import houseIcon from '../common/icons/house.png';
import coinIcon from '../common/icons/coin.png';

// Seller/buyer rows use the brand house/coin photos; following rows use the
// outline building glyph. Fresh activity is signalled by the row's count badge
// alone: a tinted tile existed here once, but My places and My buying interests
// have no equivalent, so it read as noise rather than as a pattern.
export type RowVariant = 'seller' | 'buyer' | 'building';

// Following rows show the outline building icon (file 4FpcyaiutzOU5WsPhYu6DG).
// Inlined rather than <img> so it stays crisp at 32px — the exported SVG carries
// width/height="100%" + preserveAspectRatio="none", which stretch and blur in a
// fixed-size box.
export const BuildingGlyph = () => (
  <svg viewBox="0 0 32 32" width="32" height="32" fill="none" aria-hidden="true">
    <g opacity="0.8" fill="#131c20">
      <path d="M13.6667 18.6667H11V16H13.6667V18.6667Z" />
      <path d="M21 18.6667H18.3333V16H21V18.6667Z" />
      <path d="M13.6667 12H11V9.33333H13.6667V12Z" />
      <path d="M21 12H18.3333V9.33333H21V12Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.6667 2.66667C25.6122 2.66667 28 5.05448 28 8V30.6667H4V8C4 5.05448 6.38781 2.66667 9.33333 2.66667H22.6667ZM9.33333 5.33333C7.86057 5.33333 6.66667 6.52724 6.66667 8V28H14.6667V24H17.3333V28H25.3333V8C25.3333 6.52724 24.1394 5.33333 22.6667 5.33333H9.33333Z"
      />
    </g>
  </svg>
);

/**
 * The rounded tile in front of an Activity row: the listing's own photo when it
 * has one, otherwise the illustration for its variant. Shared by the section
 * list and the row detail header so the two renderings cannot drift apart.
 */
const ActivityRowVisual = ({
  variant,
  image,
  className = '',
}: {
  variant: RowVariant;
  image?: string | null;
  className?: string;
}) => (
  <div
    className={`activity-view__row-visual activity-view__row-visual--${variant}${
      className ? ` ${className}` : ''
    }`}
  >
    {image && (
      <img className="activity-view__row-photo" src={image} alt="" aria-hidden="true" />
    )}
    {!image && variant === 'seller' && (
      <img className="activity-view__row-img" src={houseIcon} alt="" aria-hidden="true" />
    )}
    {!image && variant === 'buyer' && (
      <img className="activity-view__row-img" src={coinIcon} alt="" aria-hidden="true" />
    )}
    {!image && variant === 'building' && <BuildingGlyph />}
  </div>
);

export default ActivityRowVisual;
